import HomePage from './components/HomePage';

export const homePage = {
  firstLevel: HomePage,
};